// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-OO4","colMin":"styles_colMin__2qZUs"};